import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './formViewer.actions';
import { showConfirmationModal } from '../Common/Components/confirmation/confirmation.actions.js';
import {
  dismissOptOutModal,
  showOptOutConfirmationModal
} from "./optOutConfirmation/optOutConfirmation.actions";
import FormViewer from './formViewer';
import { injectIntl } from 'react-intl';


function mapStateToProps(state) {
  return {
    isLoading: state.formViewer.isLoading,
    isSaving: state.formViewer.isSaving, 
    unansweredCount: state.formViewer.unansweredCount,    
    formInstance: state.formViewer.formInstance,
    isFormModified: state.formViewer.isFormModified,
    isFormCancelRequested: state.formViewer.isFormCancelRequested,
    isFormDeclineRequested: state.formViewer.isFormDeclineRequested,
    isFormNotAvailable: state.formViewer.isFormNotAvailable,    
    formInstanceActionTakenDisplay: state.formViewer.formInstanceActionTakenDisplay,
    lastAutoSave: state.formViewer.lastAutoSave,
    isSessionExpiring: state.formViewer.isSessionExpiring, 
    videoConfiguration: state.video.configuration,
    isVideoV2ConfigurationLoaded: state.video.isVideoV2ConfigurationLoaded,
    videoV2Configuration: state.video.videoV2Configuration
  };
}

function mapActionsToProps(dispatch) {
  return bindActionCreators({
    ...actions,    
    showConfirmationModal: showConfirmationModal,
    showOptOutConfirmationModal: showOptOutConfirmationModal,
    dismissOptOutModal: dismissOptOutModal,
  }, dispatch);
}

export default injectIntl(connect(mapStateToProps, mapActionsToProps)(FormViewer));